import { useMemo, useCallback } from "react";
import { DatePicker } from "@salestrak/ui";

type DateInputProps = {
  value: unknown;
  onChange: (value: unknown) => void;
};

function toISODateTime(date: Date): string {
  return date.toISOString();
}

/** Date picker input for filter panels. */
export function DateInput({ value, onChange }: DateInputProps) {
  const dateValue = useMemo(() => {
    if (typeof value !== "string" || !value) return null;
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }, [value]);

  const handleChange = useCallback(
    (date: Date | null) => {
      onChange(date ? toISODateTime(date) : null);
    },
    [onChange],
  );

  return (
    <DatePicker
      value={dateValue}
      onValueChange={handleChange}
      placeholder="Select date..."
      size="sm"
    />
  );
}
